
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toODataString } from '@progress/kendo-data-query';
import { Observable ,  BehaviorSubject ,  Subscription } from 'rxjs';
import { Response } from '@angular/http';
import * as moment from 'moment-timezone';


import { RIAHelper } from '../core/ria-helper'
import { environment } from '../../environments/environment'
import { AuditAvl_AuditSchedule } from './models/AuditAvl_AuditSchedule-model'
import { MsgResult, } from './models/msg-result';
import { FixToODataString } from './fix-to-odata-string';
import { ConvertToDateTimeString} from './date-time-helper';
import { AuditAvl_AuditProperty } from '../core/models/AuditAvl_AuditProperty-model'
import { AuditStd_StandardAuditProperties } from '../core/models/audit-std_standard-audit-properties';

import { dynamicSort } from './dynamic-sort';

@Injectable()
abstract class RISDomainService extends BehaviorSubject<GridDataResult> {

  private RIABASE_URL: string = environment.baseWebApiUrl + 'api/RIA/';
  private BASE_URL_API: string = environment.baseWebApiUrl + 'api/AuditAvl_AuditScheduleNext/';


  constructor(private http: Http, private tableName: string,
  ) {
    super(null);
  }

  public getGridData(state: any) {
    return this.fetch(state);
  }

  private filterToString({ filter }: { filter?: string }): string {
    return filter ? `&$filter=${filter}` : '';
  }

  public ConvertDatesForMonitor(rootResults: any[]) {

    rootResults.forEach((x, i: number, arr: any[]) => {
      x.PickedUpForProcessing = RIAHelper.ConvertToDate(x.PickedUpForProcessing);
      x.PlacedOnQueue = RIAHelper.ConvertToDate(x.PlacedOnQueue);
      x.AuditJobCompleted = RIAHelper.ConvertToDate(x.AuditJobCompleted);
      x.ProcessAuditWhen = RIAHelper.ConvertToDate(x.ProcessAuditWhen);
    });
  }

  public ConvertDates(rootResults: any[]) {

    rootResults.forEach((x, i: number, arr: any[]) => {

      x.Season1StartDate = RIAHelper.ConvertToDate(x.Season1StartDate);
      x.Season1EndDate = RIAHelper.ConvertToDate(x.Season1EndDate);
      x.Season2StartDate = RIAHelper.ConvertToDate(x.Season2StartDate);
      x.Season2EndDate = RIAHelper.ConvertToDate(x.Season2EndDate);
      x.Season3StartDate = RIAHelper.ConvertToDate(x.Season3StartDate);
      x.Season3EndDate = RIAHelper.ConvertToDate(x.Season3EndDate);
      x.Season4StartDate = RIAHelper.ConvertToDate(x.Season4StartDate);
      x.Season4EndDate = RIAHelper.ConvertToDate(x.Season4EndDate);
      x.Season5StartDate = RIAHelper.ConvertToDate(x.Season5StartDate);
      x.Season5EndDate = RIAHelper.ConvertToDate(x.Season5EndDate);
      x.Season6StartDate = RIAHelper.ConvertToDate(x.Season6StartDate);
      x.Season6EndDate = RIAHelper.ConvertToDate(x.Season6EndDate);

    })

  }

  /*
  Convert Dates To CST
  */

  public ConvertDatesToCST(date):string {
    let newdate: moment.Moment;
    if(date!=undefined && date!=null){
      newdate = moment.utc(date).tz('America/Chicago');
      if(newdate!=undefined && newdate != null){
        return newdate.toString().substring(0, 15);
      }
    }
    return "";
  }

  public fetch(state: any): Observable<GridDataResult> {

    var stateStr = FixToODataString(state);
    var filterStr = this.filterToString(state);
    const queryStr = `${stateStr}&$count=true${filterStr}`;
//for the monitor grid
    let service = "GetCustomerAuditList";

    return this.http
      .post(this.RIABASE_URL + service, {}).pipe(
      map(response => response.json()),
      map((response) => {
        if (response) {

          this.ConvertDatesForMonitor(response);

          let sorted = response;
          if (state.sort && state.sort.length > 0 && state.sort[0].dir ) {
            let srt = state.sort[0];
            let srtFn = dynamicSort(srt.field, srt.dir);
            sorted = sorted.sort(srtFn);
          }
          let subsetSorted = sorted.slice(state.skip, state.skip + state.take);
          return ({
            data: subsetSorted,
            total: response.length
          });
        }
        else {
          return null;
        }
      }),);
  }


  public getRateAuditDataForImport(state: any) {
    return this.getRAImport(state);
  }

  public getRAImport(state: any): Observable<GridDataResult> {
//for create audit
    var stateStr = FixToODataString(state);
    var filterStr = this.filterToString(state);
    const queryStr = `${stateStr}&$count=true${filterStr}`;
    let service = "GetAllStandardAuditsByCustomerID";
    return this.http
      .get(this.RIABASE_URL + service).pipe(
      map(response => response.json()),
      map((response) => {
        response.forEach(item => {
          var dateProcessing = RIAHelper.ConvertDateForRateAvail(item.PickedUpForProcessing);
          item.PickedUpForProcessingString = dateProcessing.toString();
          item.UniversalAuditIDString = item.UniversalAuditID.toString();

          item.PickedUpForProcessing = RIAHelper.ConvertToDate(item.PickedUpForProcessing);
          item.PlacedOnQueue = RIAHelper.ConvertToDate(item.PlacedOnQueue);
          item.AuditJobCompleted = RIAHelper.ConvertToDate(item.AuditJobCompleted);
          item.ProcessAuditWhen = RIAHelper.ConvertToDate(item.ProcessAuditWhen);
        })

        if (state.sort && state.sort.length > 0 && state.sort[0].dir ) {
          let srt = state.sort[0];
          let srtFn = dynamicSort(srt.field, srt.dir);
          response = response.sort(srtFn);
        }
        let subsetSorted = response.slice(state.skip, state.skip + state.take);
        this.ConvertDates(subsetSorted);
        return ({
          data: subsetSorted,
          total: response.length
        });
      }),);
  }

  ImportStandardAuditProperty(AuditID: any, state: any): Observable<AuditStd_StandardAuditProperties[]> {
    let service = "AuditAVLGetStandardAuditProperties";
    return this.http
      .get(this.RIABASE_URL + service+ "?auditID=" + AuditID).pipe(
      map(response => response.json()),
      map((response) => {
        response.forEach(item => {
          item.checked = true;
          var x = item.Name.toLowerCase();
          item.NameLowerCase = x;

          var y = item.Address.toLowerCase();
          item.AddressLowerCase=y;

          //formatting date so that it can be sorted
        });
        return response;
      }),);

  }

  BuildGridDataResult(auditStd_StandardAuditProperties: AuditStd_StandardAuditProperties[], state: any): GridDataResult {
let massaged:AuditStd_StandardAuditProperties[] = auditStd_StandardAuditProperties.map( item =>{
  item.Season1StartDateString = RIAHelper.ConvertDateForRateAvail(item.Season1StartDate).toString();
  item.Season1EndDateString = RIAHelper.ConvertDateForRateAvail(item.Season1EndDate).toString();
  item.Season2StartDateString = RIAHelper.ConvertDateForRateAvail(item.Season2StartDate).toString();
  item.Season2EndDateString = RIAHelper.ConvertDateForRateAvail(item.Season2EndDate).toString();
  item.Season3StartDateString = RIAHelper.ConvertDateForRateAvail(item.Season3StartDate).toString();
  item.Season3EndDateString = RIAHelper.ConvertDateForRateAvail(item.Season3EndDate).toString();
  item.Season4StartDateString = RIAHelper.ConvertDateForRateAvail(item.Season4StartDate).toString();
  item.Season4EndDateString = RIAHelper.ConvertDateForRateAvail(item.Season4EndDate).toString();
  item.Season5StartDateString = RIAHelper.ConvertDateForRateAvail(item.Season5StartDate).toString();
  item.Season5EndDateString = RIAHelper.ConvertDateForRateAvail(item.Season5EndDate).toString();
  item.Season6StartDateString = RIAHelper.ConvertDateForRateAvail(item.Season6StartDate).toString();
  item.Season6EndDateString = RIAHelper.ConvertDateForRateAvail(item.Season6EndDate).toString();

  item.Season1StartDate = RIAHelper.ConvertToDate(item.Season1StartDate);
  item.Season1EndDate = RIAHelper.ConvertToDate(item.Season1EndDate);
  item.Season2StartDate = RIAHelper.ConvertToDate(item.Season2StartDate);
  item.Season2EndDate = RIAHelper.ConvertToDate(item.Season2EndDate);
  item.Season3StartDate = RIAHelper.ConvertToDate(item.Season3StartDate);
  item.Season3EndDate = RIAHelper.ConvertToDate(item.Season3EndDate);
  item.Season4StartDate = RIAHelper.ConvertToDate(item.Season4StartDate);
  item.Season4EndDate = RIAHelper.ConvertToDate(item.Season4EndDate);
  item.Season5StartDate = RIAHelper.ConvertToDate(item.Season5StartDate);
  item.Season5EndDate = RIAHelper.ConvertToDate(item.Season5EndDate);
  item.Season6StartDate = RIAHelper.ConvertToDate(item.Season6StartDate);
  item.Season6EndDate = RIAHelper.ConvertToDate(item.Season6EndDate);


  item.Season1StartDateCST =  this.ConvertDatesToCST(item.Season1StartDate);
  item.Season1EndDateCST =    this.ConvertDatesToCST(item.Season1EndDate);
  item.Season2StartDateCST =  this.ConvertDatesToCST(item.Season2StartDate);
  item.Season2EndDateCST =    this.ConvertDatesToCST(item.Season2EndDate);
  item.Season3StartDateCST =  this.ConvertDatesToCST(item.Season3StartDate);
  item.Season3EndDateCST =    this.ConvertDatesToCST(item.Season3EndDate);
  item.Season4StartDateCST =  this.ConvertDatesToCST(item.Season4StartDate);
  item.Season4EndDateCST =    this.ConvertDatesToCST(item.Season4EndDate);
  item.Season5StartDateCST =  this.ConvertDatesToCST(item.Season5StartDate);
  item.Season5EndDateCST =    this.ConvertDatesToCST(item.Season5EndDate);
  item.Season6StartDateCST =  this.ConvertDatesToCST(item.Season6StartDate);
  item.Season6EndDateCST =    this.ConvertDatesToCST(item.Season6EndDate);

   //formatting so -1 and 0s are cleared out when there is no expectedstart and expectedend dates
   item.Season1ExpectedPriceDefault = (item.Season1StartDateCST == "" && item. Season1EndDateCST == "") ? "": item.Season1ExpectedPrice.toString();
   item.Season2ExpectedPriceDefault = (item.Season2StartDateCST == "" && item. Season2EndDateCST == "") ? "": item.Season2ExpectedPrice.toString();
   item.Season3ExpectedPriceDefault = (item.Season3StartDateCST == "" && item. Season3EndDateCST == "") ? "": item.Season3ExpectedPrice.toString();
   item.Season4ExpectedPriceDefault = (item.Season4StartDateCST == "" && item. Season4EndDateCST == "") ? "": item.Season4ExpectedPrice.toString();
   item.Season5ExpectedPriceDefault = (item.Season5StartDateCST == "" && item. Season5EndDateCST == "" )? "": item.Season5ExpectedPrice.toString();
   item.Season6ExpectedPriceDefault = (item.Season6StartDateCST == "" && item. Season6EndDateCST == "") ? "": item.Season6ExpectedPrice.toString();
   return item;
})
    let sorted = [...massaged];
    if (state.sort && state.sort.length > 0 && state.sort[0].dir ) {
      let srt = state.sort[0];
      let srtFn = dynamicSort(srt.field, srt.dir);
      sorted = sorted.sort(srtFn);
    }
    let subsetSorted = sorted.slice(state.skip, state.skip + state.take);
    return ({

      data: subsetSorted,
      total: sorted.length
    });

  }

  public getAuditAvl_GetDetailReportDataSelectedDates(auditId: any, auditScheduleId: string, gds: string): Observable<any> {
    let service = "AuditAvlGetDetailReportDataSelectedDates";

    return this.http
      .post(this.RIABASE_URL + service, { AuditID: auditId, AuditScheduleID: auditScheduleId, GDS: gds }).pipe(
      map(response => response.json()),
      map((response) => {
        return response;
      }),);
  }

  public getAuditStd_GetDefaultRACSettingForProcessRun(auditId: any): Observable<any> {
    let service = "AuditStdGetDefaultRACSettingForProcessRun";

    return this.http
      .get(this.RIABASE_URL + service + "?auditId=" + auditId).pipe(
      map(response => response.json()));
  }
  public getAuditAvl_BuildHotelListForInteractiveReport(state: any, dateList: any, auditId: string, auditScheduleId: string, gds: string): Observable<GridDataResult> {

    let service = "AuditAvlBuildHotelListForInteractiveReport";
    return this.http
      .post(this.RIABASE_URL + service, { AuditID: auditId, AuditScheduleID: auditScheduleId, GDS: gds, dateListIn: dateList }).pipe(
      map(response => response.json()),
      map((response) => {

        let sorted = response;
        if (state.sort && state.sort.length > 0 && state.sort[0].dir ) {
          let srt = state.sort[0];
          let srtFn = dynamicSort(srt.field, srt.dir);
          sorted = sorted.sort(srtFn);
        }
        return ({
          data: sorted,
          total: response.length
        });
      }),);

  }
  //Get data for chart audit
  public GetRVChart(AuditScheduleID: any) {

    let service = 'AuditAvlGetAuditPercentages';
    return this.http.get(this.RIABASE_URL + service +"?AuditScheduleID="+ AuditScheduleID).pipe(
      map(response => response.json()));
   }

  //Deleting audit from list
  public DeleteAudit(auditID: string) {
    let service = 'AuditAvlRemoveAuditJob';
    return this.http.post(this.RIABASE_URL + service, { auditID: auditID });
  }

  //get notification template for edit
  public GetNotificationTemplate() {
    let service = 'GetNotificationTemplates';
    return this.http.get(this.RIABASE_URL + service + "?AuditType=3").pipe(  //AuditType=3 rate avail, 2 is reverseAudit, 1 rate audit
      map(response => response.json()));
  }

  //get notification name by notificationId
  public GetNotificationNameByID(notificationID: any) {
    let service = 'GetNotificationTemplateByID';
    return this.http.get(this.RIABASE_URL + service + "?NotificationTemplateID=" + notificationID).pipe(
      map(response => response.json()));
  }

  //update  audit after edit
  public UpdateAudit(objAuditAvl: AuditAvl_AuditSchedule) {
    let service = 'Update';
    return this.http.post(this.BASE_URL_API + service, objAuditAvl);
  }


  getAuditPropertyResult(scheduleId: string, auditPropertyID: string, date: Date, gdsId,state: any) {
    let dateChecked = ConvertToDateTimeString(date);
    let service = "GetAuditPropertyResult";
    let url = this.RIABASE_URL + service;
    url += "?DateChecked=" + dateChecked;
    url += "&AuditScheduleID=" + scheduleId.toLowerCase();
    url += "&AuditPropertyID=" + auditPropertyID.toLowerCase();
    url += "&GDSID=" + gdsId;
    return this.http.get(url).pipe(
      map(response => response.json()),
      map((response) => {
        let summaryGridData = response;
        if (state.sort && state.sort.length > 0 && state.sort[0].dir ) {
          let srt = state.sort[0];
          let srtFn = dynamicSort(srt.field, srt.dir);
          summaryGridData = summaryGridData.sort(srtFn);
        }
        return ({
          RootResults: summaryGridData,
          TotalCount: summaryGridData.length
        });
      }),);
  }

  getGDSCodeListFromServer(auditId: string, scheduleId: string): Observable<Response> {
    let service = 'GetReportGDSListing';
    let url = this.RIABASE_URL + service;
    return this.http.post(url, {
      AuditID: auditId,
      AuditScheduleID: scheduleId
    });
  }

  getCustomReportListByCustomerID() {
    let service = 'GetCustomReportListByCustomerID';
    let url = this.RIABASE_URL + service;
    return this.http.post(url, {});
  }

  getCustomReportData(auditId: string, scheduleId: string, gds: string) {
    let service = 'GetCustomReportData';
    let url = this.RIABASE_URL + service;
    return this.http.post(url, {
      AuditID: auditId,
      AuditScheduleID: scheduleId,
      GDS: gds
    });
  }

  public CreateAuditAvl(objAdvl): Observable<MsgResult> {

    let service = 'CreateAuditAvl';
    return this.http.post(this.BASE_URL_API + service, objAdvl).pipe(
      map(response => response.json()));
  }

  public SaveCustomReport(objAdvl) {
    let  service = 'SaveAuditAvlCustomReport';
    return this.http.post(this.BASE_URL_API+service,objAdvl).pipe(
      map(response => response.json()));
  }

  public DeleteCustomReport(objAdvl) {
    let service = 'DeleteAuditAvlCustomReport';
    return this.http.post(this.BASE_URL_API+service, objAdvl).pipe(
      map(response => response.json()));
  }
}



@Injectable()
export class RvService extends RISDomainService {
  constructor(http: Http) { super(http, "AuditAvl_Audit"); }
}
